import React, { memo, useEffect } from 'react'
import Nosidebar from '@/components/NoSidebar'
import { useTranslation } from 'react-i18next'
import styles from './index.module.scss'
import Shape2 from '@/assets/images/shape2.png'
import cls from 'classnames'
import { useUserList } from '@/hooks/user'
import { UserRelationsModel } from '@/services/apis/user/model'
import cacheUtil, { CACHE_WORKSPACE_KEY } from '@/utils/cache'

import { useNavigate } from 'react-router-dom'
const Home = memo(() => {
  const { t } = useTranslation()
  const teamList = useUserList()
  const navigate = useNavigate()
  const changeTeam = (team: UserRelationsModel) => {
    if (!team.isAuthorizedDevice) return
    cacheUtil.set(CACHE_WORKSPACE_KEY, team.workspaceKey)
    navigate('/wallet')
  }
  useEffect(() => {
    if (teamList.length === 1) {
      changeTeam(teamList[0])
    }
  }, [teamList])

  return (
    <Nosidebar>
      <div className={styles.home}>
        <h1 className={styles.title}>{t('common.YourWallets')}</h1>
        <div className={styles.content}>
          <ul>
            {teamList?.map(item => {
              if (item) {
                return (
                  <li
                    key={item.workspaceKey}
                    className={cls([styles.teamList, !item.isAuthorizedDevice && styles.disabled])}
                    onClick={() => changeTeam(item)}
                  >
                    <div className={styles.team}>
                      <img src={item.workspacePortrait} alt="" className={styles.img} />
                      <div>
                        <div>{item.workspaceName}</div>
                        {!item.isAuthorizedDevice && (
                          <div style={{ fontSize: '12px', lineHeight: '12px' }}>
                            {t('common.disableMsg')}
                          </div>
                        )}
                      </div>
                    </div>

                    {item.isAuthorizedDevice && (
                      <div className={styles.arrow}>
                        <img src={Shape2} alt="" width={10} />
                      </div>
                    )}
                  </li>
                )
              } else {
                return null
              }
            })}
          </ul>
        </div>
      </div>
    </Nosidebar>
  )
})

export default Home
